import { createContext, useState } from "react";

type AlertDialogContextProps = {
  hidden: boolean;
  type: AlertDialogType;
  hide: () => void;
  message?: string;
  show: (type: AlertDialogType, message: string) => void;
};

export enum AlertDialogType {
  Success,
  Error,
  Loading,
}

export const AlertDialogContext = createContext<AlertDialogContextProps>({
  hidden: true,
  type: AlertDialogType.Success,
  hide: () => {},
  show: () => {},
});

export function AlertDialogProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [hidden, setHidden] = useState(true);
  const [message, setMessage] = useState("");
  const [type, setType] = useState<AlertDialogType>(AlertDialogType.Success);

  const show = (type: AlertDialogType, message: string) => {
    setHidden(false);
    setType(type);
    setMessage(message);
  };

  return (
    <AlertDialogContext.Provider
      value={{
        hidden,
        type,
        message,
        show,
        hide: () => setTimeout(() => setHidden(true), 100),
      }}
    >
      {children}
    </AlertDialogContext.Provider>
  );
}
